export const MAIN_SOURCE = 'main'

export const OVERVIEW_ROUTE_NAME = 'overview'
export const TASK_DEFINITION_ROUTE_NAME = 'tasks-definition'
export const TASK_LIST_ROUTE_NAME = 'tasks-list'
export const TASK_DETAILS_ROUTE_NAME = 'task-details'
export const TASK_NEW_ROUTE_NAME = 'tasks-new'
export const TASK_ASSIGNMENT_ROUTE_NAME = 'tasks-assignment'
export const TASK_GROUPS_ROUTE_NAME = 'tasks-groups'
export const TASK_GROUPS_PLANNING_ROUTE_NAME = 'tasks-groups-planning'

export const COMPLETED_TASKS_ROUTE_NAME = 'completed-tasks'
export const COMPLETED_TASKS_DETAILS_ROUTE_NAME = 'completed-task-details'
export const COMPLETED_TASKS_OVERVIEW_ROUTE_NAME = 'completed-tasks-overview'
export const COMPLETED_TASKS_LAYOUT_ROUTE_NAME = 'completed-tasks-layout'
export const COMPLETED_TASKS_BY_GROUP_ROUTE_NAME = 'completed-tasks-by-group'
export const COMPLETED_TASKS_BY_GROUP_DETAILS_ROUTE_NAME = 'completed-tasks-by-group-details'

// ACTIONS
export const ACTIONS_NAME = 'actions'
export const ACTIONS_LIST_ROUTE_NAME = 'actions-list'
export const ACTIONS_DETAILS_ROUTE_NAME = 'actions-details'
export const SETTINGS_ACTION_CATEGORIES = 'settings-action-categories'
export const SETTINGS_ACTION_PRIORITIES_ROUTE = 'settings-action-priorities'

// DAILY ROUND
export const DAILY_ROUND_OLD_LIST_ROUTE_NAME = 'daily-round-list'

// DAILY ROUND CHECKPOINTS
export const DAILY_ROUND_CHECKPOINTS_ROUTE_NAME = 'dr-checkpoints'
export const DAILY_ROUND_CHECKPOINTS_OVERVIEW_ROUTE_NAME = 'dr-checkpoints-overview'
export const DAILY_ROUND_CHECKPOINTS_LIST_ROUTE_NAME = 'dr-checkpoints-list'
export const DAILY_ROUND_CHECKPOINTS_CREATION_ROUTE_NAME = 'dr-checkpoints-new'
export const DAILY_ROUND_CHECKPOINTS_DETAILS_ROUTE_NAME = 'dr-details'
export const DAILY_ROUND_LIST_ROUTE_NAME = 'dr-list'
export const DAILY_ROUND_WEEKLY_ROUTE_NAME = 'dr-weekly-round'
export const DAILY_ROUND_DETAILS_ROUTE_NAME = 'dr-round-details'
export const DAILY_ROUND_ACTIVITIES_DETAILS_ROUTE_NAME = 'dr-activity-details'
export const DAILY_ROUND_LOGBOOK_ROUTE_NAME = 'dr-messages'
export const DAILY_ROUND_LOGBOOK_ROUTE_LIST_NAME = "dr-messages-list"
export const DAILY_ROUND_LOGBOOK_NEW_ROUTE_NAME = 'dr-messages-new'
export const DAILY_ROUND_LOGBOOK_DETAILS_ROUTE_NAME = 'dr-messages-details'


// GEMBA WALK CHECKPOINTS

export const GEMBA_WALK_ACTIVITIES_DETAILS_ROUTE_NAME = 'gw-activity-details'
export const GEMBA_WALK_ASSESSMENT_DETAILS_ROUTE_NAME = 'gw-assessment-details'
export const GEMBA_WALK_BY_CHECKPOINT_DETAILS_ROUTER_NAME = 'gw-by-checkpoint-details'
export const GEMBA_WALK_BY_CHECKPOINT_LIST_ROUTER_NAME = 'gw-by-checkpoint-list'
export const GEMBA_WALK_CHECKPOINTS_CREATION_ROUTE_NAME = 'gw-checkpoints-new'
export const GEMBA_WALK_CHECKPOINTS_DETAILS_ROUTE_NAME = 'gw-details'
export const GEMBA_WALK_CHECKPOINTS_LIST_ROUTE_NAME = 'gw-checkpoints-list'
export const GEMBA_WALK_CHECKPOINTS_OVERVIEW_ROUTE_NAME = 'gw-checkpoints-overview'
export const GEMBA_WALK_CHECKPOINTS_ROUTE_NAME = 'gw-checkpoints'
export const GEMBA_WALK_DETAILS_ROUTE_NAME = 'gw-round-details'
export const GEMBA_WALK_LIST_ROUTE_NAME = 'gw-list'

export const MENU_OVERVIEW_TOKEN = 'common.messages.menu_at_a_glance'
export const MENU_LIST_TOKEN = 'common.messages.menu_list'
export const GEMBA_WALK_MENU_BY_CHECKPOINT_TOKEN = 'gemba_walk.messages.menu_by_checkpoint'

export const CAUSE_DETAILS_ROUTE = 'cause-details'

// ALERTS
export const ALERTS_ROUTE_NAME = 'alerts'
export const ALERTS_OVERVIEW_ROUTE_NAME = 'alerts-overview'
export const ALERTS_LIST_ROUTE_NAME = 'alerts-list'
export const ALERT_CREATION_ROUTE_NAME = 'alert-new'
export const ALERT_DETAILS_ROUTE_NAME = 'alert-details'
export const FACE_TO_FACE_ROUTE_NAME = 'face-to-face'
export const FACE_TO_FACE_DETAILS_ROUTE_NAME = 'face-to-face-details'

// IMPROVEMENT IDEAS
export const IMPROVEMENT_IDEAS_CREATION_ROUTE_NAME = 'improvement-idea-new'
export const IMPROVEMENT_IDEAS_DETAILS_ROUTE_NAME = 'improvement-idea-details'
export const IMPROVEMENT_IDEAS_LIST_ROUTE_NAME = 'improvement-ideas-list'
export const IMPROVEMENT_IDEAS_NAME = 'improvement-ideas'
export const IMPROVEMENT_IDEAS_OVERVIEW_ROUTE_NAME = 'improvement-ideas-overview'
export const SETTINGS_IMPROVEMENT_IDEAS_DETAILS_ROUTE_NAME = 'settings-improvement-ideas-details'

// DIAGNOSIS ROUTES
export const DIAGNOSIS_DETAIL_ROUTE = 'fundamental-detail'

// PROBLEM SOLVING
export const PROBLEM_SOLVING_LIST_ROUTE = 'problem-solving-list'
export const SETTINGS_PROBLEM_SOLVING_ACTION_CATEGORIES = 'settings-problem-solving-action-categories'

// VIRTUAL TRAINING
export const VIRTUAL_TRAINING_ROUTE_NAME = 'virtual-training'

// VISUAL STANDARD
export const VISUAL_STANDARD_EVALUATION_RESULTS_ROUTE = 'standard-evaluation-results'
export const SETTINGS_VS_ERGONOMICS_LIST_ROUTE = 'standard-ergonomics-levels-configuration'

// OK FIRST PART
export const OK_FIRST_PART = 'ok_first_part'
export const OK_FIRST_PART_ROUTE_NAME = 'ok-first-part'
export const OK_FIRST_PART_TASK_DEFINITION_ROUTE_NAME = 'ok-first-part-task-definition'
export const OK_FIRST_PART_CREATION_ROUTE_NAME = 'ok-first-part-new'
export const OK_FIRST_PART_DETAILS_ROUTE_NAME = 'ok-first-part-details'
export const OK_FIRST_PART_SCHEDULE_DETAILS_ROUTE_NAME = 'ok-first-part-schedule-details'
export const OK_FIRST_PART_OVERVIEW_ROUTE_NAME = 'ok-first-part-overview'
export const OK_FIRST_PART_SCHEDULE_LIST_ROUTE_NAME = 'ok-first-part-list'
export const OK_FIRST_PART_ASSESSMENT_DETAILS_ROUTE_NAME = 'ok-first-part-assessment-details'
export const OK_FIRST_PART_BY_CHECKPOINT_LIST_ROUTER_NAME = 'ok-first-part-by-checkpoint-list'
export const OK_FIRST_PART_BY_CHECKPOINT_DETAILS_ROUTER_NAME = 'ok-first-part-by-checkpoint-details'
export const OK_FIRST_PART_CHECKPOINT_VERSIONS_ROUTE_NAME = 'ok-first-part-versions'

export const OK_FIRST_PART_MENU_BY_CHECKPOINT_TOKEN = 'ok_first_part.messages.menu_by_checkpoint'

// ROTATION TABLE
export const ROTATION_TABLE_ROUTE_NAME = 'rotation-table'
export const ROTATION_TABLE_DETAIL_ROUTE_NAME = 'rotation-table-detail'
export const ROTATION_TABLE_WORKING_TIME_REPORT_ROUTE_NAME = 'rotation-table-working-time-report'

// ACCOUNT ROUTES
export const ACCOUNT_ROUTE = 'account'
export const MY_ACCOUNT_ROUTE = 'my-account'

// HSE RISKS
export const HSE_RISKS_ROUTE_NAME = 'hse-risks'
export const HSE_RISKS_LIST_ROUTE_NAME = 'hse-risks-list'
export const HSE_RISKS_DETAILS_ROUTE_NAME = 'hse-risks-details'
export const HSE_RISKS_CREATION_ROUTE_NAME = 'hse-risks-new'

// PEOPLE
export const PEOPLE_DETAILS_ROUTE_NAME = 'settings-person-details'
export const PEOPLE_CERTIFICATION_DETAILS_ROUTE_NAME = 'people-certification-details'

// CERTIFICATION IN PERSON
export const CERTIFICATION_IN_PERSON_NEW_ROUTE_NAME = 'certifications-in-person-new'
export const CERTIFICATION_IN_PERSON_RENEW_ROUTE_NAME = 'certifications-in-person-renew'
// SKILL MATRIX
export const SKILL_MATRIX_LIST_ROUTE_NAME = 'skill-matrix-list'
export const SKILL_MATRIX_SETTINGS_PEOPLE_IDENTIFIER_FORMAT_NAME = 'settings-people-identifier-format'

//SHOP FLOOR MANAGEMENT
export const SHOP_FLOOR_MANAGEMENT_OVERVIEW_ROUTE_NAME = 'sfm'
export const SHOP_FLOOR_MANAGEMENT_DETAILS_ROUTE_NAME = 'sfm-topic-details'
export const SFM_KPI_CARD_DETAILS_NAME = 'sfm-kpi-card-details'

//LINE BOARD
export const LINE_BOARD_MANAGEMENT_OVERVIEW_ROUTE_NAME = 'line-board'
export const LINE_BOARD_MANAGEMENT_DETAILS_ROUTE_NAME = 'line-board-topic-details'
export const LINE_BOARD_KPI_CARD_DETAILS_NAME = 'line-board-kpi-card-details'
export const SETTINGS_SFM_CHEKCPOINTS_NAME = 'sfm-checkpoints-settings'
export const SETTINGS_SFM_CHEKCPOINT_NAME = 'sfm-checkpoints-settings-details'
export const SETTINGS_SFM_TOPICS = 'sfm-topics-settings'
export const SETTINGS_SFM_TOPICS_DETAILS = 'sfm-topics-details-settings'

// CYCLE TIME DIAGRAM
export const CYCLE_TIME_DIAGRAM = 'cycle-time-diagram'

// STANDARD WORK AUDITS
export const STANDARD_WORK_AUDIT_DETAIL_ROUTE_NAME = 'swr-detail'

export const NEW_DESIGN_ROUTES = [
  ACTIONS_DETAILS_ROUTE_NAME,
  CYCLE_TIME_DIAGRAM,
  LINE_BOARD_MANAGEMENT_DETAILS_ROUTE_NAME,
  LINE_BOARD_MANAGEMENT_OVERVIEW_ROUTE_NAME,
  SETTINGS_ACTION_CATEGORIES,
  SETTINGS_PROBLEM_SOLVING_ACTION_CATEGORIES,
  SETTINGS_ACTION_PRIORITIES_ROUTE,
  SETTINGS_IMPROVEMENT_IDEAS_DETAILS_ROUTE_NAME,
  SETTINGS_SFM_CHEKCPOINT_NAME,
  SETTINGS_SFM_CHEKCPOINTS_NAME,
  SETTINGS_SFM_TOPICS_DETAILS,
  SETTINGS_SFM_TOPICS,
  SETTINGS_VS_ERGONOMICS_LIST_ROUTE,
  SFM_KPI_CARD_DETAILS_NAME,
  SHOP_FLOOR_MANAGEMENT_DETAILS_ROUTE_NAME,
  SHOP_FLOOR_MANAGEMENT_OVERVIEW_ROUTE_NAME,
  SKILL_MATRIX_SETTINGS_PEOPLE_IDENTIFIER_FORMAT_NAME,
]
